import { useEffect, useState } from 'react';

/**
 * Returns `false` during SSR and during the first client render. Returns
 * `true` after the first client-side effect (post-hydration).
 *
 * Use to gate UI that has different state between server (SSG-rendered as
 * anonymous/empty) and client (auth-aware, localStorage-aware, etc.).
 * Both renders BOTH return `false`, ensuring hydration matches. The
 * post-effect re-render swaps to the real client UI.
 *
 * Trade-off: signed-in users see the anonymous UI for ~1 paint cycle
 * (~16 ms) after hydration. Accepted as a known SSG constraint.
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
